import routes from '../../routes';

import getRouterName from './getRouterName';

const { Router } = routes;

const isSameRoute = (path: string) => {
  const currentRoute = getRouterName(Router.asPath)?.name;
  const routeName = getRouterName(path)?.name;

  return routeName === currentRoute;
};

export default isSameRoute;
